// Orange theme
const orange = {
  id: 'orange',
  name: 'Oranssi',
  price: 25,
  main: '#cf6900',
  light: '#ffa726',
  dark: '#e65100',
  bg: '#fff3e0',
  darkBg: '#2d2517',
  isSuper: false,
  surfaces: {
    // Light mode
    lightBg: '#ffe0b2',
    lightPaper: '#fff3e0',
    lightContainer: '#fff3e0',
    lightOnSurface: '#2e1a00',
    lightOnSurfaceVariant: '#6a4e28',
    lightOutline: '#a07840',
    // Dark mode
    containerLowest: '#221a0e',
    containerLow: '#0f0a04',
    container: '#221a0e',
    containerHigh: '#3d3020',
    containerHighest: '#483a28',
    bright: '#554432',
    onSurface: '#ffecd8',
    onSurfaceVariant: '#d4b08a',
    outline: '#a07840',
    outlineVariant: '#6a4e28',
    // Button colors — primary
    primaryContainer: '#ffa726',
    onPrimaryContainer: '#3d1e00',
    // Button colors — secondary (outlined)
    secondaryContainer: '#3d2a10',
    onSecondaryContainer: '#e8c090',
    // Button colors — secondary (filled)
    secondary: '#ffcc80',
    onSecondary: '#4e2c00',
    secondaryLight: '#e65100',
    onSecondaryLight: '#ffffff',
    // Button colors — inverse
    inverseSurface: '#fff3e0',
    onInverseSurface: '#2d2517',
    inverseSurfaceLight: '#2d2517',
    onInverseSurfaceLight: '#ffecd8',
    // Button colors — label/text
    labelColor: '#ffa726',
    labelColorLight: '#e65100',
    // Status colors
    success: '#4caf50',
    successLight: '#81c784',
    successDark: '#2e7d32',
    warning: '#f57c00',
    warningLight: '#ffa726',
    warningDark: '#e65100',
    error: '#ef5350',
    errorLight: '#ff7961',
    errorDark: '#c62828',
  },
};

export default orange;
